(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const radios = [...root.querySelectorAll('input[name="id"]')];
    const submit = root.querySelector('[data-tryon-submit]');
    function select(input, updateURL) {
      if (!input) return;
      root.querySelectorAll('[data-tryon-image]').forEach(el => { el.hidden = el.dataset.tryonImage !== input.value; });
      root.querySelectorAll('[data-tryon-price]').forEach(el => { el.hidden = el.dataset.tryonPrice !== input.value; });
      root.querySelector('[data-tryon-name]').textContent = input.dataset.name;
      submit.disabled = input.disabled;
      root.querySelector('[data-tryon-add]').hidden = input.disabled;
      root.querySelector('[data-tryon-unavailable]').hidden = !input.disabled;
      if (updateURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url);
      }
    }
    radios.forEach(input => input.addEventListener('change', () => select(input, true)));
    const initial = radios.find(input => input.checked);
    const requestedVariant = new URL(location.href).searchParams.get('variant');
    select(initial, Boolean(initial && requestedVariant && requestedVariant !== initial.value));
    // Native Shopify product form preserves cart handling and a no-JavaScript fallback.
  }
  function scan() { document.querySelectorAll('[data-tryon]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
